import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latest = articles.slice(0, 3);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-secondary-50/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-label text-accent-500 tracking-widest mb-2">
            ✦ ARTICLES ✦
          </p>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            最新文章
          </h2>
          <p className="text-sm text-foreground-600 max-w-md mx-auto">
            了解嫩小兔的最新动态、养护知识和品牌故事
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-background-50/80 backdrop-blur-sm text-foreground-700 whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                  <span>{article.publishedAt}</span>
                  <span>·</span>
                  <span>{article.readTime}阅读</span>
                </div>
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to={`/article/${articles[0].slug}`}
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-background-100 text-foreground-800 font-medium text-sm hover:bg-primary-50 hover:text-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            查看更多文章
            <i className="ri-arrow-right-line text-lg"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}